import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Balance.scss";
import arrow from "../../../assets/arrow.png";
import { useState } from "react";
import Footer from "../../../components/Footer/Footer";
import { Link } from "react-router-dom";
import axios from "axios";



export const destinyProfiles = {
  1: {
    title: "Balance Number 1 – The Self-Reliant Responder",
    keywords: "Confidence · Independence · Control",
    overview:
      "Balance Number 1 shows that you respond to challenges with confidence and self-reliance. You prefer handling problems on your own.",
    strengths: [
      "Strong self-control during stress",
      "Decisive problem-solving",
      "Independent thinking"
    ],
    challenges: [
      "Stubborn reactions",
      "Difficulty accepting help",
      "Emotional rigidity"
    ],
    guidance:
      "Balance independence with openness. Support does not reduce strength."
  },

  2: {
    title: "Balance Number 2 – The Emotional Stabiliser",
    keywords: "Calmness · Sensitivity · Diplomacy",
    overview:
      "Balance Number 2 indicates a calm and sensitive response to challenges. You seek harmony and prefer peaceful solutions.",
    strengths: [
      "Emotional awareness",
      "Diplomatic handling of issues",
      "Ability to calm tense situations"
    ],
    challenges: [
      "Emotional overwhelm",
      "Indecisiveness",
      "Avoiding confrontation"
    ],
    guidance:
      "Stand firm when needed. Emotional strength grows with confidence."
  },

  3: {
    title: "Balance Number 3 – The Expressive Responder",
    keywords: "Communication · Positivity · Expression",
    overview:
      "Balance Number 3 reflects a tendency to deal with stress through expression, communication and optimism.",
    strengths: [
      "Positive outlook",
      "Ability to communicate emotions",
      "Emotional resilience through creativity"
    ],
    challenges: [
      "Avoiding seriousness",
      "Emotional inconsistency",
      "Scattered reactions"
    ],
    guidance:
      "Channel emotions constructively. Focus brings emotional balance."
  },

  4: {
    title: "Balance Number 4 – The Practical Responder",
    keywords: "Discipline · Order · Stability",
    overview:
      "Balance Number 4 shows a practical and disciplined approach to challenges. You rely on logic, structure and routine.",
    strengths: [
      "Logical problem-solving",
      "Emotional stability",
      "Reliable reactions under stress"
    ],
    challenges: [
      "Rigidity",
      "Resistance to change",
      "Over-controlling tendencies"
    ],
    guidance:
      "Flexibility enhances stability. Adaptation strengthens control."
  },

  5: {
    title: "Balance Number 5 – The Adaptive Responder",
    keywords: "Flexibility · Movement · Change",
    overview:
      "Balance Number 5 indicates an adaptive and flexible response to challenges. You handle stress through change and action.",
    strengths: [
      "Quick adjustment",
      "Ability to think on your feet",
      "Emotional adaptability"
    ],
    challenges: [
      "Restlessness",
      "Impulsive reactions",
      "Difficulty staying grounded"
    ],
    guidance:
      "Pause before acting. Awareness brings emotional balance."
  },

  6: {
    title: "Balance Number 6 – The Responsible Responder",
    keywords: "Care · Responsibility · Support",
    overview:
      "Balance Number 6 reflects a caring and responsible response to stress. You naturally take charge of others’ well-being.",
    strengths: [
      "Supportive emotional response",
      "Strong sense of duty",
      "Protective nature"
    ],
    challenges: [
      "Over-responsibility",
      "Emotional burden",
      "Neglecting self-care"
    ],
    guidance:
      "Care for yourself as much as you care for others."
  },

  7: {
    title: "Balance Number 7 – The Analytical Responder",
    keywords: "Analysis · Introspection · Observation",
    overview:
      "Balance Number 7 shows an analytical and inward response to challenges. You prefer reflection and solitude to regain balance.",
    strengths: [
      "Calm analytical thinking",
      "Emotional detachment under pressure",
      "Strong intuition"
    ],
    challenges: [
      "Emotional withdrawal",
      "Overthinking",
      "Isolation"
    ],
    guidance:
      "Balance reflection with communication. Sharing eases stress."
  },

  8: {
    title: "Balance Number 8 – The Controlled Responder",
    keywords: "Authority · Control · Strength",
    overview:
      "Balance Number 8 indicates a strong, controlled and authoritative response to challenges. You face stress head-on.",
    strengths: [
      "Strong emotional control",
      "Leadership during crises",
      "Goal-focused reactions"
    ],
    challenges: [
      "Stress accumulation",
      "Power struggles",
      "Work-pressure dominance"
    ],
    guidance:
      "Release pressure gradually. Balance control with compassion."
  },

  9: {
    title: "Balance Number 9 – The Compassionate Responder",
    keywords: "Empathy · Understanding · Emotional depth",
    overview:
      "Balance Number 9 reflects a compassionate and emotionally deep response to challenges. You absorb emotions strongly.",
    strengths: [
      "Emotional understanding",
      "Empathy toward others",
      "Ability to emotionally uplift"
    ],
    challenges: [
      "Emotional overwhelm",
      "Difficulty letting go",
      "Self-sacrifice"
    ],
    guidance:
      "Protect your emotional boundaries. Compassion starts with self-care."
  },

  11: {
    title: "Balance Number 11 – The Intuitive Responder",
    keywords: "Intuition · Sensitivity · Awareness",
    overview:
      "Balance Number 11 is a Master Number indicating heightened emotional sensitivity and intuitive reactions during stress.",
    strengths: [
      "Strong intuition",
      "Deep emotional insight",
      "Inspirational response under pressure"
    ],
    challenges: [
      "Anxiety",
      "Emotional overload",
      "Nervous tension"
    ],
    guidance:
      "Ground your emotions. Calm awareness restores balance."
  },

  22: {
    title: "Balance Number 22 – The Grounded Responder",
    keywords: "Stability · Responsibility · Control",
    overview:
      "Balance Number 22 reflects a mature and responsible response to challenges. You handle pressure with discipline and patience.",
    strengths: [
      "Emotional maturity",
      "Strong stress tolerance",
      "Practical response to crises"
    ],
    challenges: [
      "Heavy pressure",
      "Fear of mistakes",
      "Over-responsibility"
    ],
    guidance:
      "Divide challenges into steps. Balance grows through steady action."
  },
};


const Balance = () => {

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    year: "2000",
    month: "May",
    day: "26",
    gender: "male" // ✅ DEFAULT, NO UI
  });


  const [resultData, setResultData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showReport, setShowReport] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName, year, month, day } = formData;
    const birthDay = Number(day);
    const birthMonth = new Date(`${month} 1, 2000`).getMonth() + 1;
    const birthYear = Number(year);

    try {
      setLoading(true);

      const { gender } = formData;

      const res = await axios.get(
        `https://core-c343.onrender.com/api/lucky-number` +
        `?firstName=${firstName}` +
        `&lastName=${lastName}` +
        `&birthYear=${birthYear}` +
        `&birthMonth=${birthMonth}` +
        `&birthDay=${birthDay}` +
        `&gender=${gender}`
      );


      setResultData(res.data);
      setShowReport(true);
    } catch (err) {
      setResultData({
        error: "Unable to generate your Destiny Number report. Please try again.",
      });
      setShowReport(true);
    } finally {
      setLoading(false);
    }
  };

  const handleTryAgain = () => {
    setShowReport(false);
    setResultData(null);
  };

  const destinyNum = resultData?.data?.numerology?.balanceNumber;
  const profile = destinyNum ? destinyProfiles[destinyNum] : null;

  return (
    <div className="destiny-container">
      <InnerNav />

      <div className="destiny-content">
        <Zodiac />

        <div className="left-numerology">

          {/* FORM VIEW */}
          {!showReport && (
            <>
<div className="header">
  <h1>Balance Number Calculator</h1>
  <p>
    Enter your name to discover how you <strong>emotionally respond to challenges, stress, and life’s situations</strong>.
  </p>
</div>


              <div className="form-card">
                <form onSubmit={handleSubmit} className="form-grid">

                  <input
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />

                  <input
                    name="middleName"
                    placeholder="Middle Name (Optional)"
                    value={formData.middleName}
                    onChange={handleChange}
                  />

                  <input
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />

                  <div className="dob-grid">
                    <select name="day" value={formData.day} onChange={handleChange}>
                      {[...Array(31)].map((_, i) => (
                        <option key={i + 1}>{i + 1}</option>
                      ))}
                    </select>

                    <select name="month" value={formData.month} onChange={handleChange}>
                      {[
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                      ].map((m) => (
                        <option key={m}>{m}</option>
                      ))}
                    </select>

                    <select name="year" value={formData.year} onChange={handleChange}>
                      {Array.from({ length: 110 }).map((_, i) => {
                        const y = 2025 - i;
                        return <option key={y}>{y}</option>;
                      })}
                    </select>
                  </div>
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>


                  <button type="submit" className="primary-btn" disabled={loading}>
                    {loading ? "Generating..." : "Show My Destiny Number"}
                  </button>

                </form>
              </div>
            </>
          )}

          {/* REPORT VIEW */}
          {showReport && (
            <div className="report-card">

              <h1>Your Balance Number Report</h1>

              {resultData?.error ? (
                <p className="error-text">{resultData.error}</p>
              ) : (
                <>
                  <div className="hero-number-box">
                    <div className="number-circle">{destinyNum}</div>
                    <h2>{profile?.title}</h2>
                    <p className="keywords">{profile?.keywords}</p>
                  </div>

                  <div className="report-section">
                    <h3>Overview</h3>
                    <p>{profile?.overview}</p>
                  </div>

                  <div className="report-section">
                    <h3>Your Strengths</h3>
                    <ul>{profile?.strengths.map((s, i) => <li key={i}>{s}</li>)}</ul>
                  </div>

                  <div className="report-section">
                    <h3>Your Challenges</h3>
                    <ul>{profile?.challenges.map((c, i) => <li key={i}>{c}</li>)}</ul>
                  </div>

                  <div className="report-section">
                    <h3>Guidance</h3>
                    <p>{profile?.guidance}</p>
                  </div>
                </>
              )}

              <button className="try-again-btn" onClick={handleTryAgain}>
                Try Again
              </button>
            </div>
          )}
        </div>

        {/* RIGHT SIDEBAR */}
        <div className="right-numerology">
          <h4>Related Links</h4>
          <div className="right-links">
            <Link to="/numerology/luckynum"><p><img src={arrow} /> Lucky Number</p></Link>
            <Link to="/numerology/chinese-lucky"><p><img src={arrow} /> Chinese Lucky</p></Link>
            <Link to="/numerology/unlucky"><p><img src={arrow} /> Unlucky Number</p></Link>
            <Link to="/numerology/life-path"><p><img src={arrow} /> Life Path</p></Link>
            <Link to="/numerology/destiny"><p><img src={arrow} /> Destiny Number</p></Link>
            <Link to="/numerology/birth"><p><img src={arrow} /> Birth or Root Number</p></Link>
            <Link to="/numerology/soul"><p><img src={arrow} /> Soul Urge Number</p></Link>
            <Link to="/numerology/name"><p><img src={arrow} /> Name Number</p></Link>
            <Link to="/numerology/balance"><p><img src={arrow} /> Balance Number</p></Link>
            <Link to="/numerology/lo-shu-grid"><p><img src={arrow} /> Lo Shu Grid Analysis</p></Link>
            <Link to="/numerology/kua"><p><img src={arrow} /> Kua Number</p></Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Balance;